// extracted by mini-css-extract-plugin
export default {"subjectSelect":"w2L1g8Ss1LVn8zyC29Yw"};